export var SavedFilterType;
(function (SavedFilterType) {
    SavedFilterType[SavedFilterType["SYSTEM"] = 0] = "SYSTEM";
    SavedFilterType[SavedFilterType["PRIVATE"] = 10] = "PRIVATE";
    SavedFilterType[SavedFilterType["PUBLIC"] = 20] = "PUBLIC";
})(SavedFilterType || (SavedFilterType = {}));
;
//# sourceMappingURL=saved-filter-type.enum.js.map